import React, {useEffect, useState} from 'react'
import {getOrderByOpsOrderId} from 'actions/ordersActions'
import {useSelector, useDispatch} from 'react-redux'
import {orderByOpsOrderIdSelector} from 'selectors'
import {useQuery} from 'hooks/useQuery'
import {getProductNavPath} from 'services/productNavigationServices'
import {useHistory, Redirect} from 'react-router-dom'

const RedirectRoute = () => {
  const dispatch = useDispatch()
  const location = useQuery()
  const opsOrderId = location.get('opsOrderId')
  const productOrderId = location.get('productOrderId')
  const history = useHistory()
  const order = useSelector(orderByOpsOrderIdSelector)
  const [redirectRoute, setRedirectRoute] = useState('')

  useEffect(() => {
    if (opsOrderId || productOrderId) dispatch(getOrderByOpsOrderId(opsOrderId, productOrderId))
  }, [dispatch, opsOrderId, productOrderId])

  useEffect(() => {
    if (Object.entries(order).length) {
      setRedirectRoute(getProductNavPath(order))
    }
  }, [history, order])
  return redirectRoute ? <Redirect to={redirectRoute} /> : null
}

export default RedirectRoute
